import styled from 'styled-components';
import { TableMixin } from '../../mixins/components/TableMixin';
export var StyledTable = /*#__PURE__*/styled.table.withConfig({
  displayName: "StyledTable",
  componentId: "c11n-8-107-0__sc-11t7upb-0"
})(["", ""], TableMixin);